import type { KarteUserFilteringRule } from '@/types/app'

// FIXME: 処理も持ってくる
export const emptyKarteUserFilteringRule: KarteUserFilteringRule = {
  annualIncome: {
    min: 0,
    max: Number.MAX_SAFE_INTEGER,
  },
  partnerAnnualIncome: {
    min: 0,
    max: Number.MAX_SAFE_INTEGER,
  },
  saving: {
    min: 0,
    max: Number.MAX_SAFE_INTEGER,
  },
  investment: {
    min: 0,
    max: Number.MAX_SAFE_INTEGER,
  },
  totalAssets: {
    min: 0,
    max: Number.MAX_SAFE_INTEGER,
  },
  monthlyInsuranceFee: {
    min: 0,
    max: Number.MAX_SAFE_INTEGER,
  },
  loanBalance: {
    min: 0,
    max: Number.MAX_SAFE_INTEGER,
  },
  generation: [],
  prefecture: null,
  city: null,
  sex: null,
  hasPartner: null,
  hasChild: null,
  hasAnswered: null,
  hasConcern: null,
  channel: null,
  jobIds: [],
}
